/**
 * The few presentation helpers the Finance home's Month end card and the Spread over tab share. The month end, its
 * prepayments and its recurring accruals are One objects (`finance_accruals_and_prepayments_module`'s concepts.yaml),
 * rendered from their record views: nothing here computes a figure or words a state.
 */

/** "2026-09" from a Date: the calendar month it falls in, in UTC. */
function isoMonth(date: Date): string {
  return date.toISOString().slice(0, 7);
}

/** The month a close opens on by default: the one that has just ended. */
export function monthJustEnded(today: Date): string {
  return isoMonth(
    new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1)),
  );
}

/** "September 2026" from "2026-09". */
export function monthLabel(month: string): string {
  const [y, m] = month.split("-").map(Number);
  return new Intl.DateTimeFormat("en-GB", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(y!, m! - 1, 1)));
}

/** "1 Oct 07:00", in London time. */
export function formatStamp(iso: string): string {
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/London",
  }).format(new Date(iso));
}
